/* ============================================================
   AMGZAL — premium enhancements (motion + dynamic commerce)
   Vanilla JS, no dependencies. Loads after amgzal.js.
   Reads config from window.AMGZAL (printed in layout/theme.liquid).
   ============================================================ */
(function () {
  'use strict';
  var CFG = window.AMGZAL || {};
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll reveal ---------- */
  function markReveals() {
    // Auto-tag common editorial blocks so every section animates in.
    var sel = [
      '.amg-sec__head', '.amg-card', '.amg-2col__img', '.amg-2col__text',
      '.amg-cols__item', '.amg-cat', '.amg-pdp__info', '.amg-acc',
      '[data-amg-reveal]'
    ].join(',');
    var vh = window.innerHeight || 800;
    qsa(sel).forEach(function (el) {
      if (el.classList.contains('amg-fade') || el.classList.contains('is-in')) return;
      // Don't hide anything already on screen — avoids an above-the-fold flash.
      if (reduce || el.getBoundingClientRect().top < vh * 0.9) return;
      el.classList.add('amg-fade');
    });
  }
  function runReveal() {
    var items = qsa('.amg-fade');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var sibs = Array.prototype.indexOf.call(el.parentNode.children, el);
          el.style.transitionDelay = Math.min(sibs, 6) * 70 + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Hero parallax + header scroll state ---------- */
  var header = qs('.amg-header');
  var heroImg = qs('.amg-hero img');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset || 0;
      if (header) header.classList.toggle('is-scrolled', y > 12);
      // Parallax only on larger screens — cheaper and smoother on phones.
      // (Image object-position is left to the theme's per-device focus setting.)
      var wide = window.innerWidth >= 768;
      var inner = qs('.amg-hero__inner');
      if (inner && !reduce && wide) {
        inner.style.transform = 'translateY(' + Math.min(y * 0.12, 60) + 'px)';
        inner.style.opacity = String(Math.max(0, 1 - y / 620));
      }
      var bt = qs('.amg-totop');
      if (bt) bt.classList.toggle('is-on', y > 700);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- 3. Back-to-top ---------- */
  function backToTop() {
    var b = document.createElement('button');
    b.className = 'amg-totop';
    b.type = 'button';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '&#8593;';
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(b);
  }

  /* ---------- 4. Count-up numbers (e.g. craft 01..04) ---------- */
  function countUp() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var hasData = el.hasAttribute('data-count');
        var target = parseInt(hasData ? el.getAttribute('data-count') : el.textContent.trim(), 10);
        if (isNaN(target)) { io.unobserve(el); return; }
        var pad = hasData ? 0 : el.textContent.trim().length;
        var pre = el.getAttribute('data-prefix') || '';
        var suf = el.getAttribute('data-suffix') || '';
        var n = 0, step = Math.max(1, Math.ceil(target / 26));
        var t = setInterval(function () {
          n += step; if (n >= target) { n = target; clearInterval(t); }
          el.textContent = pre + (pad ? String(n).padStart(pad, '0') : String(n)) + suf;
        }, 34);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    qsa('.amg-cols__num, [data-count]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- 5. PDP lightbox + zoom ---------- */
  function lightbox() {
    var main = qs('[data-amg-main]');
    if (!main) return;
    main.style.cursor = 'zoom-in';
    var box = document.createElement('div');
    box.className = 'amg-lightbox';
    box.innerHTML = '<button class="amg-lightbox__x" aria-label="Close">&#10005;</button><img alt="">';
    document.body.appendChild(box);
    var lbImg = qs('img', box);
    function open(src) { lbImg.src = src; box.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; }
    function close() { box.classList.remove('is-on'); document.documentElement.style.overflow = ''; }
    main.addEventListener('click', function () { open(main.src); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.amg-lightbox__x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // subtle zoom-on-move
    if (!reduce) {
      var wrap = main.parentNode;
      wrap.addEventListener('mousemove', function (e) {
        var r = wrap.getBoundingClientRect();
        main.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        main.style.transform = 'scale(1.28)';
      });
      wrap.addEventListener('mouseleave', function () { main.style.transform = ''; });
    }
  }

  /* ---------- 6. Quick-add from cards ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-amg-quickadd]');
    if (!qa) return;
    e.preventDefault();
    e.stopPropagation();
    var id = qa.getAttribute('data-amg-quickadd');
    if (!id) return;
    var label = qa.textContent;
    qa.textContent = 'Adding…';
    qa.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); })
      .then(function () {
        qa.textContent = 'Added ✓';
        var opener = qs('[data-amg-cart-open]');
        if (opener) opener.click();
        setTimeout(function () { qa.textContent = label; qa.disabled = false; }, 1400);
      }).catch(function () { qa.textContent = label; qa.disabled = false; });
  });

  /* ---------- 7. Recently viewed ---------- */
  var RV_KEY = 'amgzal:recent';
  function readRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (x) { return []; } }
  function recordRV() {
    var node = qs('[data-amg-product]');
    if (!node) return;
    var item = {
      h: node.getAttribute('data-handle'),
      t: node.getAttribute('data-title'),
      p: node.getAttribute('data-price'),
      i: node.getAttribute('data-image'),
      u: node.getAttribute('data-url')
    };
    if (!item.h) return;
    var list = readRV().filter(function (x) { return x.h !== item.h; });
    list.unshift(item);
    list = list.slice(0, 8);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (x) {}
  }
  function renderRV() {
    var host = qs('[data-amg-recent]');
    if (!host) return;
    var current = host.getAttribute('data-current') || '';
    var list = readRV().filter(function (x) { return x.h && x.h !== current; }).slice(0, 4);
    if (!list.length) return;
    host.innerHTML =
      '<div class="amg-wrap" style="padding:10px 22px 80px">' +
      '<h2 class="amg-serif" style="font-size:clamp(26px,3.4vw,40px);margin:0 0 26px">Recently viewed</h2>' +
      '<div class="amg-grid">' +
      list.map(function (x) {
        return '<a class="amg-card" href="' + x.u + '">' +
          '<div class="amg-card__media">' + (x.i ? '<img src="' + x.i + '" alt="' + (x.t || '') + '" loading="lazy">' : '') + '</div>' +
          '<div class="amg-card__row"><div><div class="amg-card__name">' + (x.t || '') + '</div></div>' +
          '<div class="amg-card__price">' + (x.p || '') + '</div></div></a>';
      }).join('') +
      '</div></div>';
    host.style.display = 'block';
  }

  /* ---------- 8. Newsletter popup ---------- */
  function newsletterPopup() {
    var p = CFG.popup;
    if (!p || !p.on) return;
    if (sessionStorage.getItem('amgzal:popup') === '1') return;
    if (window.Shopify && window.Shopify.designMode) return;
    var wrap = document.createElement('div');
    wrap.className = 'amg-pop';
    wrap.innerHTML =
      '<div class="amg-pop__card">' +
        '<button class="amg-pop__x" aria-label="Close">&#10005;</button>' +
        '<span class="amg-eyebrow" style="color:var(--amg-terracotta)">' + (p.eyebrow || 'AMGZAL') + '</span>' +
        '<h3 class="amg-serif">' + (p.title || '') + '</h3>' +
        '<p>' + (p.text || '') + '</p>' +
        '<form method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="newsletter,popup">' +
          '<input type="email" name="contact[email]" required placeholder="' + (p.placeholder || 'Your email') + '">' +
          '<button type="submit" class="amg-btn amg-btn--dark">' + (p.button || 'Get the code') + '</button>' +
        '</form>' +
        (p.code ? '<div class="amg-pop__code">Use code <b>' + p.code + '</b> at checkout</div>' : '') +
      '</div>';
    function close() { wrap.classList.remove('is-on'); sessionStorage.setItem('amgzal:popup', '1'); setTimeout(function () { wrap.remove(); }, 400); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('.amg-pop__x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrap.classList.contains('is-on')) close(); });
    document.body.appendChild(wrap);
    var shown = false;
    function show() { if (shown) return; shown = true; wrap.classList.add('is-on'); }
    setTimeout(show, Math.max(1500, (p.delay || 6) * 1000));
    window.addEventListener('scroll', function once() { if ((window.pageYOffset || 0) > 1200) { show(); window.removeEventListener('scroll', once); } }, { passive: true });
  }

  /* ---------- 9. Countdown timers ---------- */
  function countdowns() {
    qsa('[data-amg-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-amg-countdown')).getTime();
      if (isNaN(end)) return;
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.textContent = el.getAttribute('data-ended') || 'Drop is live'; return; }
        var days = Math.floor(d / 86400000), h = Math.floor(d % 86400000 / 3600000),
            m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
        el.innerHTML = [[days, 'D'], [h, 'H'], [m, 'M'], [s, 'S']].map(function (u) {
          return '<span class="amg-cd__u"><b>' + String(u[0]).padStart(2, '0') + '</b><i>' + u[1] + '</i></span>';
        }).join('');
        requestAnimationFrame(function () {});
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- PDP gallery: arrows + swipe (thumb click lives in amgzal.js) ---------- */
  function gallery() {
    var main = qs('[data-amg-main]');
    var thumbs = qsa('[data-amg-thumb]');
    if (!main || thumbs.length < 2) return;

    // Preload every full-size image so switching is instant (served from
    // cache) instead of a fresh network fetch on each click.
    thumbs.forEach(function (t) {
      var u = t.getAttribute('data-amg-thumb');
      if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; }
    });
    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
      return 0;
    }
    function show(i) {
      i = (i + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      main.src = t.getAttribute('data-amg-thumb');
      thumbs.forEach(function (n) { n.classList.toggle('is-active', n === t); });
      try { t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } catch (x) {}
    }
    var prev = qs('[data-amg-gal-prev]'), next = qs('[data-amg-gal-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(activeIndex() - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(activeIndex() + 1); });
    document.addEventListener('keydown', function (e) {
      if (qs('.amg-lightbox.is-on')) return; // lightbox handles its own keys
      if (e.key === 'ArrowLeft') show(activeIndex() - 1);
      else if (e.key === 'ArrowRight') show(activeIndex() + 1);
    });
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(activeIndex() + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- init ---------- */
  function init() {
    markReveals();
    gallery();
    runReveal();
    backToTop();
    countUp();
    lightbox();
    recordRV();
    renderRV();
    newsletterPopup();
    countdowns();
    onScroll();
    // Re-run reveal when Shopify theme editor injects/reloads a section.
    document.addEventListener('shopify:section:load', function () { markReveals(); runReveal(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
